import React, { Component } from "react";
import PropTypes from "prop-types";
import Header from "../components/Header.js";
import icon from "../images/icone-guarde-seu-documento.png";
import api from "./api";
import toast from "react-simple-toasts";
export class DocumentSignedList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stringBase64: null,
      loading: false,
      idDocSel: null,
      nameDoc: "",
    };
  }

  handleClick = async (id, index) => {
    this.setState({ loading: true });

    var requestRollbar = {
      apiGet: `/signedDocument/${this.props.identifier}?docId=${id}`,
    };
    this.props.funRollbar(requestRollbar);

    api
      .get(`/signedDocument/${this.props.identifier}?docId=${id}`)
      .then((response) => {
        this.props.funRollbar(response);
        this.setState({ loading: false, idDocSel: index });
        this.setState({ stringBase64: response.data.document, loading: false, idDocSel: index, nameDoc: response.data.name });
        document.getElementById("download").click();
      })
      .catch((error) => {
        this.setState({ loading: false });
        this.props.onError(error);
      });
  };

  render() {
    return (
      <div className="container h-100">
        <Header logo={this.props.logo} />
        <div className="row text-center px-4" style={{ minHeight: "calc(100vh - 106px)" }}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5">
            <img src={icon} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block" />
            <h1 className="card-title fw-bold text-white mt-3">GUARDE SEUS DOCUMENTOS</h1>
            {/* {this.props.useNotary ? (
              <h5 className="card-text text-light mt-5">O processo de assinatura do seu documento será registrado em um dos cartórios de RTDPJ do Brasil.</h5>
            ) : ( */}
            <h5 className="card-text text-light mt-5">A Confia não armazena seu documento. Não esqueça de salvar e guardar o arquivo.</h5>
            {/* )} */}
            {!this.state.loading ? (
              <ul style={{ listStyleType: "none" }}>
                {this.props.doc.docIds.map((value, index) => {
                  return (
                    <li key={index}>
                      <h5 className="card-text text-light mt-5">
                        SALVAR DOCUMENTO &nbsp;&nbsp;{index + 1} &nbsp;&nbsp;&nbsp;&nbsp;
                        <i className="fa fa-download" onClick={() => this.handleClick(value, index + 1)}></i>
                      </h5>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div className="row justify-content-center">
                <div className="col-12 d-grid">
                  <main className="position-relative">
                    <div className="loading-bar-container ">
                      <div className=" loading-bar-container loading-bar" />
                    </div>
                    <h5 className="position-absolute start-50 translate-middle mt-4">Aguarde...</h5>
                  </main>
                </div>
              </div>
            )}
          </div>
        </div>
        <a id="download" style={{ display: "none" }} className="text-white" download={`${this.state.nameDoc}.pdf`} href={`data:application/octet-stream;base64,${this.state.stringBase64}`} />
      </div>
    );
  }
}

DocumentSignedList.propTypes = {
  doc: PropTypes.object.isRequired,
  onError: PropTypes.func.isRequired,
  identifier: PropTypes.string.isRequired,
  funRollbar: PropTypes.func.isRequired,
  useNotary: PropTypes.bool.isRequired,
};

export default DocumentSignedList;
